module.exports = __webpack_public_path__ + "img/JD.68a1f57b.svg";